/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Batch_ImportInputs */

const en_batch_import = /** @type {(inputs: Batch_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Batch Import`)
};

const fr_batch_import = /** @type {(inputs: Batch_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importation par lots`)
};

const de_batch_import = /** @type {(inputs: Batch_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stapelimport`)
};

const it_batch_import = /** @type {(inputs: Batch_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importazione in batch`)
};

const ru_batch_import = /** @type {(inputs: Batch_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пакетный импорт`)
};

const es_batch_import = /** @type {(inputs: Batch_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importación por lotes`)
};

const zh_cn2_batch_import = /** @type {(inputs: Batch_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`批量导入`)
};

const ja_batch_import = /** @type {(inputs: Batch_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`バッチインポート`)
};

const hi_batch_import = /** @type {(inputs: Batch_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बैच आयात`)
};

const pt_pt2_batch_import = /** @type {(inputs: Batch_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importação em lote`)
};

/**
* | output |
* | --- |
* | "Batch Import" |
*
* @param {Batch_ImportInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const batch_import = /** @type {((inputs?: Batch_ImportInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Batch_ImportInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_batch_import(inputs)
	if (locale === "de") return de_batch_import(inputs)
	if (locale === "it") return it_batch_import(inputs)
	if (locale === "ru") return ru_batch_import(inputs)
	if (locale === "es") return es_batch_import(inputs)
	if (locale === "zh-CN") return zh_cn2_batch_import(inputs)
	if (locale === "ja") return ja_batch_import(inputs)
	if (locale === "hi") return hi_batch_import(inputs)
	if (locale === "pt-PT") return pt_pt2_batch_import(inputs)
	return en_batch_import(inputs)
});